import { AbAgentsType, AgentType, FormType } from '@models/AppModels';

export const defaultSliderSettings = {
    temperature: 1,
    maxTokens: 256,
    topP: 1,
    frequencyPenalty: 0,
    presencePenalty: 0,
} as const;

export const agentsOptions = ['qwen-plus', 'qwen-turbo', 'qwen-max'] as const;

export const imageModelsOptions = [
    'dall-e-2',
    'dall-e-3',
    'gpt-image-1',
    'qwen-image-3.0',
    'qwen-image-3.0-pro',
] as const;

export const imageSizesOptions = [
    '1024x1024',
    '1792x1024',
    '1024x1792',
    '1536x1024',
    '1024x1536',
    '512x512',
    '256x256',
    'auto',
] as const;

export const defaultSettings: AgentType = {
    _id: '',
    title: '',
    summary: '',
    systemStarterPrompt: '',
    beforeUserSentencePrompt: '',
    afterUserSentencePrompt: '',
    firstChatSentence: '',
    model: agentsOptions[0],
    temperature: null,
    maxTokens: null,
    topP: null,
    frequencyPenalty: null,
    presencePenalty: null,
    stopSequences: [],
    imageModel: 'qwen-image-3.0',
    imageSize: '1024x1024',
    imagePromptTemplate: '',
    imageCount: 1,
    directImageGeneration: false,
    providerId: '',
    minPromptLength: null,
    maxPromptLength: null,
};

export const defaultAbAgents: AbAgentsType = {
    agentA: null,
    distA: 50,
    agentB: null,
    distB: 50,
} as const;

export const defaultExperiment = {
    title: '',
    description: '',
    agentsMode: 'Single',
    activeAgent: null,
    abAgents: null,
    isActive: true,
    maxMessages: undefined,
    maxConversations: undefined,
    maxParticipants: undefined,
    displaySettings: {
        welcomeHeader: 'Welcome to MAYA\n欢迎来到 MAYA',
        welcomeContent:
            'Welcome to MAYA, an experimental platform designed for research on generative AI (GI) and user behavior. MAYA provides a controlled research environment for exploring how users interact with and respond to AI-generated content.\n\n欢迎来到 MAYA——一个专为生成式人工智能（GI）与用户行为研究设计的实验平台。MAYA 提供了一个受控的研究环境，用于探索用户如何与 AI 生成的内容互动并作出反应。',
    },
    experimentForms: {
        registration: null,
        preConversation: null,
        postConversation: null,
    },
    experimentFeatures: {
        userAnnotation: false,
        streamMessage: false,
        training: false,
        imageSelection: false,
        stageOrder: ['preSurvey', 'training', 'conversation'],
    },
} as const;

export const initialSlidersEnabled = {
    temperatureEnabled: false,
    maxTokensEnabled: false,
    topPEnabled: false,
    frequencyPenaltyEnabled: false,
    presencePenaltyEnabled: false,
} as const;

export const ApiPaths = {
    CONVERSATIONS_PATH: 'conversations',
    USERS_PATH: 'users',
    DATA_AGGREGATION_PATH: 'dataAggregation',
    AGENTS_PATH: 'agents',
    EXPERIMENTS_PATH: 'experiments',
    FORMS_PATH: 'forms',
    TRAINING_PATH: 'training',
    PROVIDERS_PATH: 'providers',
    SYSTEM_PATH: 'system',
} as const;

export const AdminSections = {
    STUDY_OVERVIEW: 'study-overview',
    AGENTS: 'agents',
    EXPERIMENTS: 'experiments',
    FORMS: 'forms',
    TRAINING: 'training',
    DATA: 'data',
    SETTINGS: 'settings',
} as const;

export const defaultQuestionProps = {
    'binary-radio-selector': {
        fieldKey: '',
        label: '示例：这是二选一题目：',
        required: true,
        screenOut: false,
        correctAnswer: '',
    },
    'scale-radio': {
        fieldKey: '',
        label: '请在量表上选择：',
        left: '左端选项',
        right: '右端选项',
        range: 5,
        required: true,
        numbered: false,
        screenOut: false,
        correctAnswer: '',
    },
    'selection-text-input': {
        fieldKey: '',
        label: '请选择一项',
        required: true,
        selectionOptions: [{ label: '选项 1', value: 'option1' }],
        screenOut: false,
        correctAnswer: '',
    },
    'number-input': {
        fieldKey: '',
        label: '请输入数字',
        min: 0,
        max: 100,
        defaultValue: null,
        required: true,
        screenOut: false,
        correctAnswer: '',
    },
    'radio-selection': {
        fieldKey: '',
        label: '请选择以下选项之一：',
        required: true,
        selectionOptions: [{ label: '选项 1', value: 'option1' }],
        screenOut: false,
        correctAnswer: '',
    },
    'text-input': {
        fieldKey: '',
        label: '请填写你的回答：',
        required: true,
        minLength: 0,
        maxLength: 0,
        rows: 4,
        screenOut: false,
        correctAnswer: '',
    },
};

export const defaultForm: FormType = {
    name: '未命名问卷',
    title: '',
    instructions: '',
    questions: [{ type: 'selection-text-input', props: defaultQuestionProps['selection-text-input'] }],
};
